import { Autocomplete, Box, Button, Grid, InputLabel, TextField, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useLocation, useNavigate, useNavigation, useParams } from "react-router-dom";
import RightViewLayout from "../../components/RighViewLayout";
import CustomInput from "../../components/CustomInput";
import {REACT_LOCATION} from "@/router/ReactEndPoints";
import { useSnackbar } from "notistack";
import CommonUtil from "../../util/CommonUtils";
import { editCityZone, getZoneById } from "@/services/CityZoneService";
import { useTranslation } from "react-i18next";

export default function EditCityZone1() {
    const params = useParams();
    const { enqueueSnackbar } = useSnackbar();
    const location = useLocation();
    const navigate = useNavigate();
    const { t } = useTranslation();
    const [cityZone, setCityZone] = useState({
        id: "",
        name: "",
        code: "",
        createdAt: "",
        updatedAt: "",
        createdBy: "",
        updatedBy: "",
        createRequestedBy: "",
        updateRequestedBy: ""
    })

    const [error, setError] = useState({
        name: "",
        code: "",
        city: "",
    });

    useEffect(() => {
        getZoneById(params.id).then((response) => {
            console.log("getZoneById response:", response);
            if (response.data.code === "LVLI0000" && response.data.data) {
                console.log("Zone data:", response.data.data);
                setCityZone(response.data.data);
            }
        })
    }, [])
    const handleChange = (event) => {
        const name = event.target.name;
        setCityZone({ ...cityZone, [name]: event.target.value });
        setError({
            ...error,
            [name]: "",
            common: "",
        });
    }

    const validateForm = () => {
        if (CommonUtil.isEmptyString(cityZone.name)) {
            setError({
                ...error,
                name: t("LVL0001"),
            });
            return;
        }
        if (CommonUtil.isEmptyString(cityZone.code)) {
            setError({
                ...error,
                code: t("LVL0001"),
            });
            return;
        }
        return true;
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        let request = {
            ...cityZone
        }
        if (validateForm()) {
            console.log("request:", request)
            editCityZone(request).then((response) => {
                if (response.data.code === "LVLI0003") {
                    enqueueSnackbar(response.data.message, {
                        variant: "success",
                        anchorOrigin: {
                            horizontal: 'center',
                            vertical: 'top',
                        },
                        style: {
                            marginTop: "300px",
                        }
                    });
                    navigate(REACT_LOCATION);
                    return;
                }

                switch (response.data.code) {
                    case 'LVLE0007':
                        setError({
                            ...error,
                            name: response.data.message
                        });
                        break;
                    case 'LVLE0015':
                        setError({
                            ...error,
                            name: response.data.message
                        });
                        break;
                    case 'LVLE0008':
                        setError({
                            ...error,
                            code: response.data.message
                        });
                        break;
                    case 'LVLE0016':
                        setError({
                            ...error,
                            code: response.data.message
                        });
                        break;
                    case 'LVLE0022':
                        setError({
                            ...error,
                            name: response.data.message
                        });
                        break;
                    case 'LVLE0023':
                        setError({
                            ...error,
                            code: response.data.message
                        });
                        break;
                    case 'LVLE0026':
                        setError({
                            ...error,
                            name: response.data.message
                        });
                        break;
                    default:
                        console.log("");
                }
            })
        }
    }
    return (
        <RightViewLayout
            navigateBack={REACT_LOCATION}
            title={t('LVLLOC0046')}
        >
            <Grid container spacing={2} px={2}>
                <Grid item md={6} sm={12}>
                    <CustomInput
                        id={"EditCityZone-CustomInput-1"}
                        required
                        error={error.name}
                        label={t('LVLLOC0034')}
                        size="small"
                        name="name"
                        value={cityZone.name}
                        inputProps={{
                            maxLength: 100,
                        }}
                        helperText={error.name}
                        validation="alpha-numeric"
                        handleChange={handleChange}
                    />
                </Grid>
                <Grid item md={6} sm={12}>
                    <CustomInput
                        id={"EditCityZone-CustomInput-2 "}
                        required
                        error={error.code}
                        label={t('LVLLOC0035')}
                        size="small"
                        name="code"
                        value={cityZone.code}
                        inputProps={{
                            maxLength: 100,
                            readOnly: true
                        }}
                        helperText={error.code}
                        validation="alpha-numeric"
                        handleChange={handleChange}
                        disabled
                    />
                </Grid>
            </Grid>
            <Grid container spacing={2} px={2}>
                <Grid item sm={12}>
                    <Box display={"flex"} flexDirection={"row-reverse"}>
                        <Box item pl={2}>
                            <Button
                                id="EditCityZone1"
                                variant="contained"
                                size="large"
                                className="text-transform-none"
                                onClick={(e) => handleSubmit(e)}
                            >
                                {t('LVLLOC0036')}
                            </Button>
                        </Box>
                        <Box item>
                            <Button
                                id="EditCityZone2"
                                className="text-transform-none"
                                variant="outlined"
                                onClick={() => navigate(REACT_LOCATION)}
                                size="large"
                            >
                                {t('LVLLOC0037')}
                            </Button>
                        </Box>
                    </Box>
                </Grid>
            </Grid>
        </RightViewLayout >
    )
}
